module.exports = __webpack_public_path__ + "files/387895ecef82abbb78aea44145452935.svg";